import React from "react";
import { Link } from "react-router-dom";
import Banner from "../../assets/images/baner.png";

const CartBannerComponent = (props) => {
  
  return (
    <div>
      <div className="container">
        <div className="row my-3 my-md-4">
          <div className="col-12">
            <div className="product-details-banner-wrapper position-relative">
              <img className="img-fluid w-100" src={Banner} alt="" />
              <div className="overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
                <div className="banner-inner text-center px-3">
                  <h5 className="text-uppercase mb-2 mb-md-3 fs-4 fs-md-3">{props.title}</h5>
                  <div className="d-flex align-items-center justify-content-center flex-wrap gap-2">
                    <Link to={"/"} className="text-decoration-none">
                      <i className="fa fa-home"></i>
                    </Link>

                    <i className="fa fa-chevron-right small"></i>
                    <span className="small">{props.title}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartBannerComponent;